import {
  GlobalStyle as WCLGlobalStyle,
  UtilitiesProvider,
} from '@faxi/web-component-library';
import { GlobalStyle } from 'globalStyles';
import {
  ApplicationSection,
  BenefitsSection,
  CostsSolution,
  FaqSection,
  HowItWorksSection,
  SplashSection,
} from 'pages';
import { Fragment } from 'react';

import { Header } from './components';
import { TanstackClient } from './providers';

const App = () => {
  return (
    <Fragment>
      <WCLGlobalStyle />
      <GlobalStyle />

      <TanstackClient>
        <UtilitiesProvider>
          <Header />
          <main>
            <SplashSection />

            <HowItWorksSection />

            <BenefitsSection />

            <CostsSolution />

            <ApplicationSection />

            <FaqSection />
          </main>
        </UtilitiesProvider>
      </TanstackClient>
    </Fragment>
  );
};

export default App;
